import React, { useState, useEffect } from "react";

import "./SuccessStories.css";

const SuccessStories = () => {
  const beforeBullets = [
    "Struggled to relate college concepts to industry expectations.",
    "Lacked hands‑on exposure to projects worth showcasing.",
    "Felt nervous during interviews and tech discussions.",
    "Unsure about right tools, languages, or career paths.",
  ];

  const afterBullets = [
    "Built and shipped real‑world apps using AI, web, and cloud.",
    "Presents confidently, reviews code, and leads technical demos.",
    "Mastered full stacks through mentor‑guided sprints.",
    "Secures interviews with a sharp portfolio and clear direction.",
  ];

  const companyLogos = [
    { src: "/successstories/sp1.png", alt: "Infosys" },
    { src: "/successstories/cb1.png", alt: "Microsoft" },
    { src: "/successstories/Al1.png", alt: "Tech Mahindra" },
    { src: "/successstories/accenture.png", alt: "Accenture" },
    { src: "/successstories/cognizant.png", alt: "Cognizant" },
    { src: "/successstories/capgemini.png", alt: "capgemini" },
    { src: "/successstories/citizens-bank.jpg", alt: "citizens-bank" },
    { src: "/media/deloitte.png", alt: "deloitte" },
    { src: "/successstories/devdolphins.png", alt: "devdolphins" },
    { src: "/successstories/genpact.jpg", alt: "genpact" },
    { src: "/successstories/hcltech.png", alt: "hcltech" },
    { src: "/successstories/hexaware.png", alt: "hexaware" },
    { src: "/successstories/wipro.png", alt: "wipro" },
    { src: "/successstories/netcracker.png", alt: "netcracker" },
  ];

  const testimonials = [
    {
      src: "/successstories/I3GvDsnapedit1725291560218.jpg",
      name: "Abhinaya V, Cognizant",
      text: "“KodeZ made me job-ready, not just certificate-ready — I walked into interviews with solutions, not questions.”",
    },
    {
      src: "/successstories/vwBcYuntitleddesign.png",
      name: "Vikram A, Accenture",
      text: "“From debugging code to pitching ideas, I transformed from a learner to a leader.”",
    },
    {
      src: "/successstories/nVMWvsnapedit1724834926932.png",
      name: "Samhitha Y, Infosys",
      text: "KodeZ challenged my limits — now, solving real-world tech problems is my morning routine.",
    },
    {
      src: "/successstories/A7DpYcrct.png",
      name: "Nikhila S, Cognizant",
      text: "KodeZ turned my GitHub into a hiring magnet — every project tells a story recruiters want to hear.",
    },
    {
      src: "/successstories/30xf9snapedit1724834616447.jpg",
      name: "Shruthi G, Hexaware",
      text: "Before KodeZ, I Googled answers. After KodeZ, I started answering on Stack Overflow.",
    },
  ];

  const [logoIndex, setLogoIndex] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const logoInterval = setInterval(() => {
      setLogoIndex(prev => (prev + 1) % companyLogos.length);
    }, 1100);
    return () => clearInterval(logoInterval);
  }, [companyLogos.length]);

  useEffect(() => {
    const testimonialInterval = setInterval(() => {
      setTestimonialIndex(prev => (prev + 1) % testimonials.length);
    }, 3500);
    return () => clearInterval(testimonialInterval);
  }, [testimonials.length]);

  const getSlice = (arr, idx, type = "") => {
    const isTabletOrMobile = screenWidth < 768;

    if (type === "testimonial" && isTabletOrMobile) {
      return [arr[idx % arr.length]];
    }

    return isTabletOrMobile
      ? [arr[idx % arr.length]]
      : [
        arr[idx % arr.length],
        arr[(idx + 1) % arr.length],
        arr[(idx + 2) % arr.length],
      ];
  };

  const getResponsiveTestimonials = () => {
    const count = screenWidth >= 1024 ? 3 : screenWidth >= 768 ? 2 : 1;
    const result = [];
    for (let i = 0; i < count; i++) {
      const index = (testimonialIndex + i) % testimonials.length;
      result.push(testimonials[index]);
    }
    return result;
  };

  return (
    <section className="stories-section" id="success">
      <h2 className="stories-pill">Success Stories (Alumni Highlights)</h2>

      <div className="panel">
        <h4 className="panel-heading">🌟 From Curious to Career‑Ready 🌟
        </h4>
        <p className="panel-sub">
          How KodeZ by Robokalam Technologies transforms ambitious learners into top‑tier tech professionals.
        </p>

        <div className="before-after-wrapper">
          <div className="before-card">
            <ul>
              <h4>"Before Joining in KodeZ"</h4>
              {beforeBullets.map((b, i) => (
                <li key={i} className={i === 0 ? "label-heading" : ""}>{b}</li>
              ))}
            </ul>
          </div>

          <div className="arrow-wrapper">
            <span className="arrow arrow-desktop">➡️</span>
            <span className="arrow arrow-mobile">⬇️</span>
          </div>

          <div className="after-card">
            <ul>
              <h4>"After Choosen KodeZ"</h4>
              {afterBullets.map((b, i) => (
                <li key={i} className={i === 0 ? "label-heading" : ""}>{b}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="panel">
        <h3 className="panel-heading">
          Where <span className="kodez">KodeZ</span> Talent Ignites Impact 🔥
        </h3>
        <div className="carousel">
          <button
            className="nav-arrow"
            onClick={() => setLogoIndex((logoIndex - 1 + companyLogos.length) % companyLogos.length)}
          >
            ‹
          </button>

          {getSlice(companyLogos, logoIndex).map(({ src, alt }, i) => {
            const enlargeList = ["capgemini", "citizens-bank", "deloitte", "genpact", "netcracker", "Tech Mahindra"];
            const reduceList = ["devdolphins", "hexaware"];

            const altLower = alt.toLowerCase();
            const sizeClass = enlargeList.map(e => e.toLowerCase()).includes(altLower)
              ? "logo-enlarge"
              : reduceList.includes(altLower)
                ? "logo-reduce"
                : "";

            return <img key={i} src={src} alt={alt} className={`logo-slide ${sizeClass}`} />;
          })}

          <button
            className="nav-arrow"
            onClick={() => setLogoIndex((logoIndex + 1) % companyLogos.length)}
          >
            ›
          </button>
        </div>
      </div>

      <div className="panel">
        <h3 className="panel-heading">What They Say When No One’s Watching</h3>

        <div className="testimonial-wrapper">
          <button
            className="testimonial-arrow"
            onClick={() =>
              setTestimonialIndex((prev) =>
                prev === 0 ? testimonials.length - 1 : prev - 1
              )
            }
          />

          <div className="testimonial-carousel">
            {getResponsiveTestimonials().map(({ src, name, text }, i) => (
              <div className="test-card" key={i}>
                <img
                  src={src}
                  alt={name}

                />
                <p className="test-text">{text}</p>
                <span className="test-name">— {name}</span>
              </div>
            ))}
          </div>

          <button
            className="testimonial-arrow"
            onClick={() =>
              setTestimonialIndex((prev) => (prev + 1) % testimonials.length)
            }
          />
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
